import { useState, useEffect } from "react";
const getNetworkConnection = () => (
    navigator.connection ||
    null
)

// add connection type to Navigator
declare global {
    interface Navigator {
        connection?: Connection;
    }
}

// declare rtt on connection

declare global {
    interface NetworkInformation extends Connection {
    }
}

// extend connection interface
interface Connection {
    rtt?: number;
    type?: string;
    saveData?: boolean;
    downLink?: number;
    downLinkMax?: number;
    effectiveType?: string;
    addEventListener: (type: string, listener: EventListenerOrEventListenerObject, options?: boolean | AddEventListenerOptions) => void;
    removeEventListener: (type: string, listener: EventListenerOrEventListenerObject, options?: boolean | EventListenerOptions) => void;
}

interface NetworkInfo {
    rtt?: number;
    type?: string;
    saveData?: boolean;
    downLink?: number;
    downLinkMax?: number;
    effectiveType?: string;
    since?: string;
    online?: boolean;
}

const getNetworkConnectionInfo = () => {
    const connection = getNetworkConnection();
    if (!connection) {
        return {};
    }
    return {
        rtt: connection!.rtt,
        type: connection.type,
        saveData: connection!.saveData,
        downLink: connection!.downLink,
        downLinkMax: connection!.downLinkMax,
        effectiveType: connection!.effectiveType,
    };
}
const useNetwork = () => {
    const [state, setState] = useState<NetworkInfo>(() => {
        return {
            since: undefined,
            online: navigator.onLine,
            ...getNetworkConnectionInfo(),
        };
    });
    useEffect(() => {
        const handleOnline = () => {
            setState((prevState) => ({
                ...prevState,
                online: true,
                since: new Date().toString(),
            }));
        };
        const handleOffline = () => {
            setState((prevState) => ({
                ...prevState,
                online: false,
                since: new Date().toString(),
            }));
        };
        const handleConnectionChange = () => {
            setState((prevState) => ({
                ...prevState,
                ...getNetworkConnectionInfo(),
            }));
        };
        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);
        const connection = getNetworkConnection();
        connection?.addEventListener("change", handleConnectionChange);
        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
            connection?.removeEventListener("change", handleConnectionChange);
        };
    }, []);
    return state;
}
export default useNetwork;